import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { markAsPaid as universalMarkAsPaid, setShippingFulfillment as universalSetShippingFulfillment, sendFulfillmentConfirmation as universalSendFulfillmentConfirmation, markAsRead as universalMarkAsRead, setArchiveStatus as universalSetArchiveStatus, createOrder as universalCreateOrder, bulkFulfillOrders as universalBulkFulfillOrders, bulkMarkOrdersAsPaid as universalBulkMarkOrdersAsPaid, bulkArchiveOrders as universalBulkArchiveOrders, bulkUnarchiveOrders as universalBulkUnarchiveOrders, addFulfillerEmailWasSentActivity as universalAddFulfillerEmailWasSentActivity, declineOrder as universalDeclineOrder, updateOrderEmail as universalUpdateOrderEmail, updateOrderShippingAddress as universalUpdateOrderShippingAddress, getOrder as universalGetOrder, queryOrders as universalQueryOrders, queryOrdersEventuallyConsistent as universalQueryOrdersEventuallyConsistent, createFulfillment as universalCreateFulfillment, updateFulfillment as universalUpdateFulfillment, deleteFulfillment as universalDeleteFulfillment, } from './stores-v2-orders.universal';
import { IdentityType, WeightUnit, VatType, PaymentStatus, FulfillmentStatus, LineItemType, MediaItemType, ActivityType, InvoiceSource, ChannelType, EnteredByIdentityType, SubscriptionFrequency, ShipmentFulfillmentStatus, WebhookIdentityType, } from './stores-v2-orders.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.stores.v2.orders', module_name: 'wix-stores.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        markAsPaid: (_id, paymentInfo) => {
            const methodLogData = {
                method_name: 'markAsPaid',
                service_name: 'wix.orders.api.v2.InternalOrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.InternalOrdersV2.markAsPaid',
            };
            return universalMarkAsPaid(_id, paymentInfo, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        setShippingFulfillment: (_id, options) => {
            const methodLogData = {
                method_name: 'setShippingFulfillment',
                service_name: 'wix.orders.api.v2.InternalOrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.InternalOrdersV2.setShippingFulfillment',
            };
            return universalSetShippingFulfillment(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        sendFulfillmentConfirmation: (_id) => {
            const methodLogData = {
                method_name: 'sendFulfillmentConfirmation',
                service_name: 'wix.orders.api.v2.InternalOrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.InternalOrdersV2.sendFulfillmentConfirmation',
            };
            return universalSendFulfillmentConfirmation(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        markAsRead: (_id) => {
            const methodLogData = {
                method_name: 'markAsRead',
                service_name: 'wix.orders.api.v2.InternalOrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.InternalOrdersV2.markAsRead',
            };
            return universalMarkAsRead(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        setArchiveStatus: (_id, options) => {
            const methodLogData = {
                method_name: 'setArchiveStatus',
                service_name: 'wix.orders.api.v2.InternalOrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.InternalOrdersV2.setArchiveStatus',
            };
            return universalSetArchiveStatus(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createOrder: (order, options) => {
            const methodLogData = {
                method_name: 'createOrder',
                service_name: 'wix.orders.api.v2.OrdersWriteAPI',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersWriteAPI.createOrder',
            };
            return universalCreateOrder(order, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkFulfillOrders: (filter, options) => {
            const methodLogData = {
                method_name: 'bulkFulfillOrders',
                service_name: 'wix.orders.api.v2.OrdersWriteAPI',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersWriteAPI.bulkFulfillOrders',
            };
            return universalBulkFulfillOrders(filter, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkMarkOrdersAsPaid: (filter) => {
            const methodLogData = {
                method_name: 'bulkMarkOrdersAsPaid',
                service_name: 'wix.orders.api.v2.OrdersWriteAPI',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersWriteAPI.bulkMarkOrdersAsPaid',
            };
            return universalBulkMarkOrdersAsPaid(filter, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkArchiveOrders: (filter) => {
            const methodLogData = {
                method_name: 'bulkArchiveOrders',
                service_name: 'wix.orders.api.v2.OrdersWriteAPI',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersWriteAPI.bulkArchiveOrders',
            };
            return universalBulkArchiveOrders(filter, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUnarchiveOrders: (filter) => {
            const methodLogData = {
                method_name: 'bulkUnarchiveOrders',
                service_name: 'wix.orders.api.v2.OrdersWriteAPI',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersWriteAPI.bulkUnarchiveOrders',
            };
            return universalBulkUnarchiveOrders(filter, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        addFulfillerEmailWasSentActivity: (orderId) => {
            const methodLogData = {
                method_name: 'addFulfillerEmailWasSentActivity',
                service_name: 'wix.orders.api.v2.OrdersWriteAPI',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersWriteAPI.addFulfillerEmailWasSentActivity',
            };
            return universalAddFulfillerEmailWasSentActivity(orderId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        declineOrder: (orderId, options) => {
            const methodLogData = {
                method_name: 'declineOrder',
                service_name: 'wix.orders.api.v2.OrdersWriteAPI',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersWriteAPI.declineOrder',
            };
            return universalDeclineOrder(orderId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateOrderEmail: (orderId, options) => {
            const methodLogData = {
                method_name: 'updateOrderEmail',
                service_name: 'wix.orders.api.v2.OrdersWriteAPI',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersWriteAPI.updateOrderEmail',
            };
            return universalUpdateOrderEmail(orderId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateOrderShippingAddress: (orderId, options) => {
            const methodLogData = {
                method_name: 'updateOrderShippingAddress',
                service_name: 'wix.orders.api.v2.OrdersWriteAPI',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersWriteAPI.updateOrderShippingAddress',
            };
            return universalUpdateOrderShippingAddress(orderId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getOrder: (_id) => {
            const methodLogData = {
                method_name: 'getOrder',
                service_name: 'wix.orders.api.v2.OrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersV2.getOrder',
            };
            return universalGetOrder(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryOrders: (options) => {
            const methodLogData = {
                method_name: 'queryOrders',
                service_name: 'wix.orders.api.v2.OrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersV2.queryOrders',
            };
            return universalQueryOrders(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryOrdersEventuallyConsistent: (options) => {
            const methodLogData = {
                method_name: 'queryOrdersEventuallyConsistent',
                service_name: 'wix.orders.api.v2.OrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersV2.queryOrdersEventuallyConsistent',
            };
            return universalQueryOrdersEventuallyConsistent(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createFulfillment: (orderId, fulfillment) => {
            const methodLogData = {
                method_name: 'createFulfillment',
                service_name: 'wix.orders.api.v2.OrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersV2.createFulfillment',
            };
            return universalCreateFulfillment(orderId, fulfillment, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateFulfillment: (identifiers, options) => {
            const methodLogData = {
                method_name: 'updateFulfillment',
                service_name: 'wix.orders.api.v2.OrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersV2.updateFulfillment',
            };
            return universalUpdateFulfillment(identifiers, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteFulfillment: (identifiers) => {
            const methodLogData = {
                method_name: 'deleteFulfillment',
                service_name: 'wix.orders.api.v2.OrdersV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v2.orders,environment=velo-frontend,method-fqn=wix.orders.api.v2.OrdersV2.deleteFulfillment',
            };
            return universalDeleteFulfillment(identifiers, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        IdentityType,
        WeightUnit,
        VatType,
        PaymentStatus,
        FulfillmentStatus,
        LineItemType,
        MediaItemType,
        ActivityType,
        InvoiceSource,
        ChannelType,
        EnteredByIdentityType,
        SubscriptionFrequency,
        ShipmentFulfillmentStatus,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=stores-v2-orders.frontend.js.map